<template>
  <div class="items-list">
    <ul class="items">
      <li class="items__item" v-if="!isEditPeriod">
        <div class="items__item__content" v-if="isKindergarten || isBruttoTid">
          <p>Periode</p>
          <div class="input-group__input">
            {{ dateRangeFormatted }}
            <div class="hint--right" aria-label="Redigér periode">
              <div class="icon__bg-circle" @click="isEditPeriod = true"><span class="icon-wrench"></span></div>
            </div>
          </div>
        </div>
      </li>
      <template v-if="isEditPeriod">
        <div class="calc-method">
          <h3>Vælg beregningsmetode</h3>
          <p>Planlægges der for et helt skoleår/arbejdsår udgør arbejdstiden 1924 timer. Planlægges der for en del af et
            skoleår/arbejdsår kan I selv vælge, hvilke af flg. metoder arbejdstiden skal beregnes ud fra.</p>
          <ul class="d-radio-group">
            <li class="d-radio-group__radio"
                v-for="way in waysToCalculate"
                :key="way.value"
                :class="{'d-radio-group__radio--selected': theSelectedWayToCalculate === way.value}"
                @click="setTheSelectedWayToCalculate(way.value)">
              <input type="radio"
                     v-model="theSelectedWayToCalculate"
                     :value="way.value"
                     :id="'subject_subject_type_' + way.value">
              <label class="calc-method__label" :for="'subject_subject_type_' + way.value" v-html="way.title"></label>
            </li>
          </ul>
          <p>I nedenstående udregnes automatisk søgnehelligdage i perioden. Men du skal selv indtaste om den ansatte har
            ferie, der ikke er brugt – altså både gammel ferie og ny optjent ferie</p>
        </div>
        <li class="items__item">
          <div class="items__item__content" :class="{'items__item__content--error': isErrorInStartDate}">
            <p>Startdato</p>
            <div class="input-group__input">
              <DateSelector
                :date="startDate"
                @changed="setStartDate"
                :isOnlyShowFirstAndLastDateEachMonth="theSelectedWayToCalculate === 'month'"
              ></DateSelector>
            </div>
          </div>
          <p class="input-error" v-if="isErrorInStartDate">Skal være den første eller sidste dag i måneden</p>
        </li>
        <li class="items__item">
          <div class="items__item__content" :class="{'items__item__content--error': isErrorInEndDate}">
            <p>Slutdato</p>
            <div class="input-group__input">
              <DateSelector
                :isOnlyShowFirstAndLastDateEachMonth="theSelectedWayToCalculate === 'month'"
                :date="endDate"
                @changed="setEndDate"></DateSelector>
            </div>
          </div>
          <p class="input-error" v-if="isErrorInEndDate">Skal være den første eller sidste dag i måneden</p>
        </li>
      </template>
      <li class="items__item">
        <div class="items__item__content">
          <p>Timeansættelse pr. uge</p>
          <div class="input-group__input">
            <span class="label">timer</span>
            <input type="number"
                   v-model="hoursPerWeek.hours"
                   @change="hoursPerWeekChanged($event.target.value, true)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <li class="items__item" v-if="isBruttoTid">
        <div class="items__item__content">
          <p>Beskæftigelsesgrad</p>
          <div class="input-group__input">
            <span class="label">%</span>
            <input type="number"
                   v-model="employmentPercentage.hours"
                   @change="employmentPercentageChanged($event.target.value)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <li class="items__item" :class="{'items__item--fixed': workingHours.isFixed}">
        <div class="items__item__content">
          <p>{{ workingHours.title }}</p>
          <div class="input-group__input">
            <span class="label">timer</span>
            <input type="number" v-model="workingHours.hours"
                   @change="onEditWorkingHours($event.target.value)"
                   @focus="$event.target.select()">
          </div>
        </div>
      </li>
      <ul>
        <li class="subtract-item items__item" v-for="(subtractItem, idx) in subtractedItems" :key="subtractItem.id"
            :class="{'subtract-item--fixed': subtractItem.isFixed}">
          <div class="subtract-item__title">
            <div class="d-input-group__input__close icon__bg-circle icon__bg-circle--danger"
                 @click="deleteItem(subtractItem)">
              <span class="icon-cross2"></span>
            </div>
            {{ subtractItem.title }}
          </div>
          <div class="input-group__input">
            <span class="label">{{ subtractItem.unit ? subtractItem.unit : 'timer' }}</span>
            <input type="number" v-model="subtractItem.hours" @focus="$event.target.select()"
                   @change="setSubtractedItemValue(subtractItem, $event.target.value)">
          </div>
        </li>
      </ul>
    </ul>
    <ul class="items" id="items__list">
      <li class="items__item items__item__add__new" v-if="isAddNew">
        <input type="text" placeholder="Eks. Aldersreduktion" ref="add_new_input" v-model="newItemTitle"
               @keydown.enter="addOwn">
        <div class="items__item__add__new__buttons">
          <button class="bttn" @click="reset">Annullér</button>
          <button class="bttn bttn-primary" @click="addOwn">Gem</button>
        </div>
      </li>
    </ul>
    <DDropdown :isShowDots="false" class="add-more__dropdown">
      <p slot="title" class="items__item__add" v-if="!isAddNew">+ Tilføj reduktion</p>
      <ul slot="list">
        <label class="d-label d-label__headline">Vælg fra standard</label>
        <li v-for="(possibleItem, idx) in possibleStandardItems" @click="addFromStandard(possibleItem)">{{
            possibleItem.title
          }}
        </li>
        <li class="items__item__add" style="border-top: 1px solid #ddd;margin-top: 0.5rem" @click="setIsAddNew(true)">+
          Opret egen
        </li>
      </ul>
    </DDropdown>
    <div class="item__total"><p>Arbejdstid</p>
      <p>{{ nettoTime }} timer</p></div>
  </div>
</template>

<script>
import DDropdown from '../common/DDropdown'
import DateSelector from '../datepicker/DateSelector'
import moment from 'moment'

export default {
  components: {DDropdown, DateSelector},
  props: {
    schoolYear: {},
    isKindergarten: {
      type: Boolean,
      default: false
    },
    theEditUserNorm: {
      type: Array,
      default: () => []
    },
    isNetto: {
      default: false,
      type: Boolean
    },
    standardNettoHours: {
      default: 1686.1
    }
  },
  data () {
    return {
      isEditPeriod: false,
      initStartDate: null,
      initEndDate: null,
      startDate: null,
      endDate: null,
      isBruttoTid: true,
      theSelectedWayToCalculate: 'day',
      waysToCalculate: [
        {
          title: '7.4 timer pr. dag: <span>Dvs. 7,4 timer pr. mulig arbejdsdag. Mulige arbejdsdage er dage i delperioden der ikke er weekenddage.</span>',
          desc: '',
          value: 'day'
        },
        {
          title: '160.3 timer pr. måned: <span>Dvs. 1924 timer / 12 måneder. Så hvis man f.eks ansætter en ny pr. 1/9 2023, så er regnestykket: 1924 / 12 * 4 = årsnorm resten af året i de fire måneder.</span>',
          desc: '',
          value: 'month'
        }
      ],
      hoursPerWeek: {
        id: 'hours_per_week',
        title: 'Timeansættelse pr. uge',
        hours: 37,
        standardHours: 37,
        isFixed: false
      },
      employmentPercentage: {
        id: 'employment_percentage',
        title: 'Ansættelsesgrad',
        hours: 100,
        standardHours: 100,
        unit: 'percentage',
        isFixed: false
      },
      workingHours: {
        id: 'working_hours',
        title: 'Arbejdstid i perioden',
        hours: this.standardNettoHours,
        standardHours: this.standardNettoHours,
        isFixed: true
      },
      standardItems: [
        {
          id: 'holidays',
          title: 'Søgnehelligdage',
          hours: 0,
          standardHours: 0,
          userStandardHours: 0,
          desc: 'Søgnehelligdage er helligdage, som ikke falder på en lørdag eller søndag',
          isFixed: true,
          isSelected: false
        },
        {
          id: 'vacation',
          title: 'Ferie',
          inputType: 'number',
          hours: 185.00,
          standardHours: 185.00,
          userStandardHours: 185.00,
          unit: 'timer',
          isFixed: true,
          isSelected: false
        },
        {
          id: 'vacation_6_week',
          title: '6. Ferieuge',
          inputType: 'number',
          hours: 37.00,
          standardHours: 37.00,
          userStandardHours: 37.00,
          unit: 'timer',
          isFixed: true,
          isSelected: false
        },
        {id: 'care_days', title: 'Omsorgsdage', hours: 0, standardHours: 0, isFixed: false, isSelected: false},
        {id: 'senior_days', title: 'Seniordage', hours: 0, standardHours: 0, isFixed: false, isSelected: false},
        {
          id: 'age_reduction',
          title: 'Aldersreduktion',
          hours: 175,
          standardHours: 175.00,
          userStandardHours: 175.00,
          isFixed: true,
          isSelected: false
        }
      ],
      isEdit: false,
      isAddNew: false,
      newItemTitle: ''
    }
  },
  computed: {
    danishHolidays () {
      return this.$store.state.danishHolidays.danishHolidays
    },
    isErrorInStartDate () {
      if (this.theSelectedWayToCalculate === 'day') {
        return false
      }
      const date = moment(this.startDate)
      const isFirstDay = date.date() === 1
      const isLastDay = date.clone().add(1, 'days').date() === 1
      return !isFirstDay && !isLastDay
    },
    isErrorInEndDate () {
      if (this.theSelectedWayToCalculate === 'day') {
        return false
      }
      const date = moment(this.endDate)
      const isFirstDay = date.date() === 1
      const isLastDay = date.clone().add(1, 'days').date() === 1
      return !isFirstDay && !isLastDay
    },
    dateRangeFormatted () {
      return moment(this.startDate).format('ll') + ' - ' + moment(this.endDate).format('ll')
    },
    subtractedItems () {
      return this.standardItems.filter(item => item.isSelected)
    },
    possibleStandardItems () {
      const itemsOnlyForBrutto = ['holidays', 'vacation']
      return this.standardItems.filter(item => {
        return this.isNetto ? !itemsOnlyForBrutto.includes(item.id) && !item.isSelected : !item.isSelected
      })
    },
    nettoTime () {
      const sums = this.subtractedItems.map(item => item.hours * 1)
      const subtract = this.subtractedItems.length < 1 ? 0 : sums.reduce((sum, val) => sum + val)
      return parseFloat(this.workingHours.hours - (subtract * 1)).toFixed(2)
    },
    itemsToSave () {
      const startDate = moment(this.startDate).format('YYYY-MM-DD')
      const endDate = moment(this.endDate).format('YYYY-MM-DD')
      const periodStart = {
        id: 'period_start',
        title: 'hidden_periode_start',
        isChecked: true,
        value: startDate,
        hours: startDate
      }
      const periodEnd = {id: 'period_end', title: 'hidden_periode_end', isChecked: true, value: endDate, hours: endDate}
      const periodDates = {title: 'Periode', value: this.dateRangeFormatted}
      let arr = [periodStart, periodEnd, periodDates]
      if (this.isBruttoTid) {
        const workPercentageHidden = {title: 'hidden_ansættelsesgrad', value: this.employmentPercentage.hours}
        const workPercentage = {title: 'Ansættelsesgrad', value: this.employmentPercentage.hours + '%'}
        arr.push(workPercentageHidden, workPercentage)
      }
      arr.push(this.hoursPerWeek)
      arr.push(this.workingHours)
      arr = arr.concat(this.subtractedItems)
      return arr
    },
    numberOfSchoolDays () {
      function isNotWeekend (m) {
        return moment(m).isoWeekday() !== 6 && moment(m).isoWeekday() !== 7
      }

      let startDate = this.startDate
      const endDate = this.endDate
      const dateArray = []
      while (moment(startDate).isSameOrBefore(endDate)) {
        const m = moment(startDate).format('YYYY-MM-DD')
        if (isNotWeekend(m)) {
          dateArray.push(m)
        }
        startDate = moment(startDate).add(1, 'days')
      }
      return dateArray.length
    },
    isOnlyPartOfSchoolYear () {
      const initStartDateFormatted = this.initStartDate.format('YYYY-MM-DD')
      const startDateFormatted = this.startDate.format('YYYY-MM-DD')
      const initEndDateFormatted = this.initEndDate.format('YYYY-MM-DD')
      const endDateFormatted = this.endDate.format('YYYY-MM-DD')
      return initStartDateFormatted !== startDateFormatted || initEndDateFormatted !== endDateFormatted
    }
  },
  watch: {
    itemsToSave () {
      this.$emit('updated', this.itemsToSave)
    },
    nettoTime () {
      this.$emit('changedSum', this.nettoTime)
    },
    theEditUserNorm () {
      this.isEdit = true
      this.standardItems.forEach((standardItem, idx) => {
        this.standardItems[idx].isSelected = false
      })
      this.initStartAndEndDate()
      this.theEditUserNorm.forEach(normItem => {
        const normItemHours = normItem.value * 1
        switch (normItem.title) {
          case 'Timeansættelse pr. uge':
            this.hoursPerWeek.hours = normItemHours
            break
          case 'Periode start':
          case 'hidden_periode_start':
            this.setStartDate(normItem.value)
            break
          case 'Periode slut':
          case 'hidden_periode_end':
            this.setEndDate(normItem.value)
            break
          case 'Bruttotid':
          case 'Arbejdstid i perioden':
            this.$emit('onEditBrutto')
            this.workingHours.title = normItem.title
            this.workingHours.hours = normItemHours
            break
          case 'Nettotid':
            this.workingHours.title = normItem.title
            this.$emit('onEditNetto')
            this.workingHours.hours = normItemHours
            break
          case 'hidden_ansættelsesgrad':
            this.employmentPercentage.hours = normItemHours
            break
          case 'Periode':
          case 'Ansættelsesgrad':
          case 'Arbejdstid':
            break
          default:
            const idx = this.standardItems.findIndex(item => item.title === normItem.title)
            if (idx > -1) {
              this.standardItems[idx].hours = normItemHours
              this.standardItems[idx].isSelected = true
            } else {
              this.addOwn(normItem)
            }
            break
        }
      })
    },
    numberOfSchoolDays () {
      this.initData()
    },
    isNetto () {
      if (!this.isEdit) {
        this.initStartAndEndDate()
      }
      this.initData()
    }
  },
  methods: {
    setTheSelectedWayToCalculate (wayValue) {
      this.theSelectedWayToCalculate = wayValue
      this.initData()
    },
    initData () {
      // Dont calculate hours if a user is edited - unless the employmentperiod changes
      if (this.isEdit) {
        return
      }
      this.workingHours.title = this.isNetto ? 'Nettotid' : 'Bruttotid'
      let hoursInPeriod = this.isNetto ? this.standardNettoHours : 1924
      if (this.isOnlyPartOfSchoolYear) {
        if (this.theSelectedWayToCalculate === 'day') {
          hoursInPeriod = parseFloat(this.numberOfSchoolDays * 7.4).toFixed(2)
        } else {
          const startDate = moment(this.startDate)
          const endDate = moment(this.endDate)
          // Check if the endDate is the last day of the month
          const isLastDayOfMonth = endDate.date() === endDate.clone().endOf('month').date()
          // Calculate the number of months between the two dates
          const numberOfMonths = endDate.diff(startDate, 'months') + (isLastDayOfMonth ? 1 : 0)
          const hoursOfWork = (hoursInPeriod / 12) * numberOfMonths
          hoursInPeriod = parseFloat(hoursOfWork).toFixed(2)
        }
      }
      this.workingHours.hours = hoursInPeriod
      this.workingHours.standardHours = hoursInPeriod
      this.standardItems.forEach((item, key) => {
        const itemsToAdd = this.isNetto ? ['vacation_6_week'] : ['vacation', 'vacation_6_week', 'holidays']
        const itemsToHide = this.isNetto ? ['vacation', 'holidays'] : []
        if (itemsToAdd.indexOf(item.id) > -1) {
          this.standardItems[key].isSelected = true
        }
        if (itemsToHide.indexOf(item.id) > -1) {
          this.standardItems[key].isSelected = false
        }
      })
      this.getHolidayHours()
    },
    setStartDate (date) {
      this.startDate = date
      setTimeout(_ => {
        this.isEdit = false
      })
    },
    setEndDate (date) {
      this.endDate = date
      setTimeout(_ => {
        this.isEdit = false
      })
    },
    employmentPercentageChanged (val) {
      const inHours = (val / 100) * 37
      this.hoursPerWeek.hours = parseFloat(inHours.toFixed(2))
      this.hoursPerWeekChanged(inHours, false)
    },
    hoursPerWeekChanged (val, changePercentage) {
      let employmentRate = val / 37
      if (changePercentage) {
        let percentage = employmentRate * 100
        percentage = percentage.toFixed(0)
        this.employmentPercentage.hours = percentage
      }
      this.$emit('changedEmploymentRate', employmentRate)
      this.workingHours.hours = parseFloat(this.workingHours.standardHours * employmentRate).toFixed(2)
      this.standardItems.forEach(item => {
        if (item.userStandardHours) {
          item.hours = parseFloat(item.userStandardHours * employmentRate).toFixed(2)
        } else {
          if (item.standardHours) {
            item.hours = parseFloat(item.standardHours * employmentRate).toFixed(2)
          }
        }
      })
    },
    onEditWorkingHours (value) {
      this.workingHours.standardHours = value
      this.workingHours.isFixed = false
      if (this.isNetto) {
        this.$emit('onEditedStandardWorkingHours', value)
      }
    },
    setSubtractedItemValue (item, value) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      if (item.userStandardHours) {
        this.standardItems[idx].userStandardHours = value * 1
      }
      if (!item.standardHours || item.standardHours * 1 !== value * 1) {
        this.standardItems[idx].isFixed = false
      } else {
        this.standardItems[idx].isFixed = true
      }
    },
    setItemValue (item, idx, value) {
      if (!this.items[idx].standardHours || this.items[idx].standardHours * 1 !== value * 1) {
        this.items[idx].isFixed = false
      } else {
        this.items[idx].isFixed = true
      }
    },
    setIsAddNew (bool) {
      if (bool) {
        this.isAddNew = true
        this.$nextTick(_ => {
          this.$refs.add_new_input.focus()
        })
      } else {
        this.isAddNew = false
      }
    },
    addFromStandard (item) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      this.standardItems[idx].isSelected = true
    },
    addOwn (item) {
      const newItem = {
        id: new Date().getTime(),
        title: this.newItemTitle,
        hours: 0,
        isFixed: false,
        isSelected: true,
        isOwn: true
      }
      if (item && item.title) {
        newItem.id = item.title
        newItem.title = item.title
        newItem.hours = item.value * 1
      }
      this.standardItems.push(newItem)
      this.reset()
    },
    deleteItem (item) {
      const idx = this.standardItems.findIndex(standardItem => standardItem.id === item.id)
      if (item.isOwn) {
        this.standardItems.splice(idx, 1)
        return
      }
      this.standardItems[idx].hours = this.standardItems[idx].standardHours
      this.standardItems[idx].isFixed = true
      this.standardItems[idx].isSelected = false
    },
    reset () {
      this.newItemTitle = ''
      this.isAddNew = false
    },
    getHolidaysWithinSchoolYearRange () {
      const start = this.startDate
      const end = this.endDate
      return this.danishHolidays.filter(date => {
        const year = date.slice(6, date.length)
        const month = date.slice(3, 5)
        const day = date.slice(0, 2)
        const mDate = moment(year + month + day).format('YYYY-MM-DD')
        const isAfterStart = moment(mDate).isSameOrAfter(start)
        const isBeforeEnd = moment(mDate).isSameOrBefore(end)
        const isNotWeekend = moment(mDate).isoWeekday() < 6
        return isAfterStart && isBeforeEnd && isNotWeekend
      })
    },
    getHolidayHours () {
      const holidays = this.getHolidaysWithinSchoolYearRange()
      const holidayHours = holidays.length * 7.4
      const holidayIdx = this.standardItems.findIndex(item => item.id === 'holidays')
      this.standardItems[holidayIdx].standardHours = holidayHours.toFixed(2)
      this.standardItems[holidayIdx].hours = holidayHours.toFixed(2)
      this.standardItems[holidayIdx].userStandardHours = holidayHours.toFixed(2)
    },
    initStartAndEndDate () {
      if (this.isKindergarten) {
        this.startDate = moment(this.schoolYear.employee_time_start).set({
          month: 0, // august (0-based index)
          date: 1
        })
        this.endDate = moment(this.schoolYear.employee_time_end).set({
          month: 11, // July (0-based index)
          date: 31
        })
      } else {
        this.startDate = moment(this.schoolYear.employee_time_start).set({
          month: 7, // august (0-based index)
          date: 1
        })
        this.endDate = moment(this.schoolYear.employee_time_end).set({
          month: 6, // July (0-based index)
          date: 31
        })
      }
      this.initStartDate = this.startDate.clone()
      this.initEndDate = this.endDate.clone()
    }
  },
  beforeMount () {
    this.initStartAndEndDate()
    if (this.isNetto) {
      this.workingHours.title = 'Nettotid'
      return
    }
    if (this.isKindergarten || this.isBruttoTid) {
      this.getHolidayHours()
    }
    if (this.isBruttoTid) {
      this.workingHours.title = 'Bruttotid'
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.add-more__dropdown {
  display: inline-flex;
}

.items__item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.items__item__content--error {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 0px 0px 2px rgb(255 90 90 / 100%) !important;
  margin: -2px;
  padding: 2px;
}

.items__item__content--error + .input-error {
  font-weight: normal !important;
}

.items__item .d-input-group__input__close {
  transform: scale(0);
  width: 16px;
  height: 16px;
  font-size: 12px;
  transition: transform 0.25s;
  margin-right: 0.25rem;
}

.subtract-item:hover .d-input-group__input__close {
  transform: scale(1);
}

.items__item > input[type="number"] {
  width: 150px;
  font-weight: normal;
  background: #fff;
}

.items__item__add {
  color: var(--blue);
  cursor: pointer;
  font-size: 11px;
  font-weight: normal;
}

.items__item__add:hover {
  text-decoration: underline;
}

.items__item.items__item__add__new {
  flex-direction: column;
  font-weight: normal;
  margin-top: 1rem;
}

.items__item.items__item__add__new .items__item__add__new__buttons {
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  gap: 0.5rem;
}

.input-group__input {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.input-group__input .label {
  font-size: 0.85rem;
  margin-right: 5px;
}

.input-group__input > .icon__bg-circle {
  min-width: 30px;
  min-height: 30px;
}

.subtract-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: normal;
  margin-bottom: 0.5rem;
}

.subtract-item__title {
  display: flex;
  align-items: center;
}

.subtract-item .input-group__input input {
  padding: 6px 9px;
}

.item__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #ccc;
  border-width: 1px 0 1px 0;
  padding: 0.5rem;
  margin-top: 1rem;
}

.d-label__headline {
  margin: 0.5rem;
}

input {
  background: #fff;
}

.number-of-days-explainer {
  text-align: right;
  margin-bottom: 0.5rem;
}

.items__item--fixed > .items__item__content > .input-group__input > input[type="number"],
.subtract-item.subtract-item--fixed .input-group__input > input[type="number"] {
  background: #eeeeee;
}

.items__item--fixed > .items__item__content > .input-group__input > input[type="number"]:focus {
  background: #ffffff;
}

.calc-method {
  font-weight: normal;
  border: 1px solid #facc17;
  border-radius: 4px;
  background-color: #fefce8;
  padding: 0.5rem;
  margin-bottom: 1rem;
  font-size: 11px;
  line-height: 1.5;
  color: #a26206;
}

.calc-method p,
.calc-method h3 {
  margin: 0.5rem 0.25rem;
}

.calc-method__label {
  text-transform: initial;
  font-size: 11px;
  line-height: 1.2 !important;
  color: #a26206 !important;
  letter-spacing: 0 !important;
}
</style>



// WEBPACK FOOTER //
// AssignHoursNormList.vue?c28fa85a